import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import Loading from "../../Util/Loading";
import { useNavigate, useParams } from "react-router-dom";
import MultiSelectModal from "./MultiSelectModal";

import SelectProfessional from "./SelectProfessional";
import TimeSlotSelector from "./Timeslotselector";
import Layout from "../../Layout";
import bookingApi from "../../api/booking/BookingApi";
import sericesApi from "../../api/user/service.api";
import staffApi from "../../api/user/staff.api";

function BookingModify() {
  const { id } = useParams();
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);

  const operatorId = user?.user?._id;

  const dispatch = useDispatch();
  const [booking, setBooking] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedNailServices, setSelectedNailServices] = useState([]);
  const [selectedNailIds, setSelectedNailIds] = useState([]);

  const [selectedBeautyServices, setSelectedBeautyServices] = useState([]);
  const [selectedBeautyIds, setSelectedBeautyIds] = useState([]);

  const [selectedProfessional, setSelectedProfessional] = useState([]);

  const [selectedDateTime, setSelectedDateTime] = useState(null);

  const [note, setNote] = useState("");

  const [nails, setNails] = useState([]);
  const [beauty, setBeauty] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [totalTimeNail, setTotalTimeNail] = useState(0);
  const [totalTimeBeauty, setTotalTimeBeauty] = useState(0);

  const getBookingDetail = async () => {
    try {
      const { response } = await bookingApi.getBookingById({ id });
      if (response?.data?.booking) {
        const b = response.data.booking;
        setBooking(b);
        setSelectedNailServices(b.selectedNailServices || []);
        setSelectedBeautyServices(b.selectedBeautyServices || []);
        setSelectedProfessional(b.selectedProfessional || []);
        setSelectedDateTime(b.selectedDateTime || null);
        setSelectedNailIds(b?.selectedNailServices?._id || null);
        setSelectedBeautyIds(b?.selectedBeautyservices?._id || null);
        setNote(b.customer_info.message || "");
      } else {
        toast.error("Booking not found");
        navigate("/appointments");
      }
    } catch (error) {
      toast.error("Error loading booking");
      console.error(error);
      navigate("/appointments");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBookingDetail()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  // console.log({ booking });

  // console.log({ booking });

  const getBeautyData = async () => {
    try {
      const { response, err } = await sericesApi.getallBeauty({ operatorId });

      if (response && response.data) {
        setBeauty(response.data.beautyservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getNailData = async () => {
    try {
      const { response, err } = await sericesApi.getallNail({ operatorId });

      if (response && response.data) {
        setNails(response.data.nailservices);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await Promise.all([getBeautyData(), getNailData()]);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const getAllStaff = async () => {
    try {
      let operatorId;

      if (booking?.operator?.length > 0) {
        operatorId = booking.operator[0]._id;
      }

      if (!operatorId) {
        toast.error("Operator ID not found");
        return;
      }

      const { response, err } = await staffApi.getAllStaffInfo(operatorId);

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (booking?.operator?.length > 0) {
      getAllStaff();
    }
  }, [booking]);

  const loading = false;

  const { customer_info } = booking;

  const isCancelled = booking?.booking?.status === "cancelled";
  const isPast =
    selectedDateTime && new Date(selectedDateTime).getTime() < Date.now();

  const SectionCard = ({ title, children }) => (
    <div className="bg-white/10 p-4 rounded-2xl shadow border border-border">
      <h4 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-2">
        {title}
      </h4>
      <div>{children}</div>
    </div>
  );

  const cancelBookingHandler = () => {
    navigate(`/bookingdetail/${id}`);
  };

  const handleReactivate = async () => {};

  const handleUpdateBooking = async () => {
    try {
      const payload = {
        selectedNailServices,
        selectedBeautyServices,
        selectedProfessional,
        selectedDateTime,
        note,
      };

      console.log({ payload });
      const { response, err } = await bookingApi.updateBooking(id, payload);
      if (err) throw err;
      toast.success("Booking updated successfully!");
      getBookingDetail();
      navigate(`/booking/preview/${id}`);
    } catch (error) {
      toast.error("Failed to update booking");
      console.error(error);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Layout>
      {loading ? (
        <div className="flex-colo h-96">
          <Loading />
        </div>
      ) : (
        <div className="max-w-4xl mx-auto p-1 text-white space-y-6">
          <h2 className="text-2xl font-bold text-yellowlight border-b border-border pb-4">
            Update Appointment
          </h2>

          <MultiSelectModal
            options={nails}
            totalTime={totalTimeNail}
            setTotalTime={setTotalTimeNail}
            selectedValues={selectedNailServices}
            setSelectedValues={setSelectedNailServices}
            selectedId={selectedNailIds}
            setSelectedId={setSelectedNailIds}
            label="Nail Services"
          />

          <MultiSelectModal
            options={beauty}
            totalTime={totalTimeBeauty}
            setTotalTime={setTotalTimeBeauty}
            selectedValues={selectedBeautyServices}
            setSelectedValues={setSelectedBeautyServices}
            selectedId={selectedBeautyIds}
            setSelectedId={setSelectedBeautyIds}
            label="Beauty Services"
          />

          <SelectProfessional
            label="Professional"
            staffs={staffs}
            selectedId={selectedProfessional}
            onChange={setSelectedProfessional}
            selectedNailservices={selectedNailServices || []}
            selectedBeautyservices={selectedBeautyServices || []}
          />

          <TimeSlotSelector
            selectedDateTime={selectedDateTime}
            setSelectedDateTime={setSelectedDateTime}
            staffs={staffs}
            selectedProfessionalId={selectedProfessional}
          />

          <SectionCard title="Customer Info">
            <ul className="space-y-1">
              <li>
                <span className="text-sm text-gray-400">Name:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.name || "—"}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Email:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.email || "—"}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Phone:</span>{" "}
                <span className="text-lg font-semibold text-white">
                  {customer_info?.mobile || "—"}
                </span>
              </li>
            </ul>
          </SectionCard>
          <h2 className="text-2xl font-bold mt-8">Notes</h2>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full p-3 rounded-xl border border-yellowlight text-text bg-dry text-lg"
            rows={4}
            placeholder="Write notes about your appointment..."
          />
          <div className="pt-6 border-t border-border">
            {isCancelled ? (
              <button
                onClick={handleReactivate}
                className="w-full px-6 py-3 bg-yellowlight hover:bg-yellowdark text-black rounded-2xl font-semibold text-lg shadow"
              >
                Reactive Your Appointment
              </button>
            ) : isPast ? (
              <div className="bg-white/10 text-yellowlight text-sm sm:text-base p-4 rounded-2xl shadow border border-border text-center">
                <p className="font-semibold text-lg mb-1">
                  Cam not rebook your appointment
                </p>
                <p>
                  Sorry, the appointment date has already passed and can't be
                  modified.
                  <br className="mb-4" />
                </p>
                <button
                  onClick={() => navigate("/")}
                  className="m-3 px-6 py-3 bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark rounded-2xl font-semibold text-lg shadow"
                >
                  New Appointment
                </button>
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={cancelBookingHandler}
                  className="w-full px-6 py-3 dg-dry border border-border hover:text-red-500 text-yellowlight rounded-2xl font-semibold text-lg shadow"
                >
                  Cancel
                </button>

                <button
                  onClick={handleUpdateBooking}
                  className="w-full px-6 py-3 bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark rounded-2xl font-semibold text-lg shadow"
                >
                  Updated
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}

export default BookingModify;
